import logo from "./Assets/logo.png";
import insurerLogo from "./Assets/digit.png";

export const config = {
    planDetails: {
        name: "CARE_IITRAA",
        duration: "12",
        durationType: "months",
        paymentMode: "online",
        insurer: "CARE",
    },
    siteLogo: logo,
    insurerLogo: insurerLogo,
    policyRepository:'https://drive.google.com/drive/folders/1BBRkMVMOYJKCfWfivCIYKT8IctP7kKjW?usp=sharing',
    faqMap: [
        // Eligibility
        {
            ques: "Will this plan work in conjunction with my group health insurance scheme provided by my employer?",
            ans: "Yes. Absolutely.",
        },
        {
            ques: "Will this plan work in conjunction with an individual health insurance plan that I have already purchased?",
            ans: "Yes. Absolutely.",
        },
        // {
        //     ques: "Will this plan work in conjunction with the existing health insurance plan from IMTA that I have already purchased?",
        //     ans: "Yes. Absolutely"
        // },
        {
            ques: "If the primary/base insurance holder is a non-IIT spouse, with an IIT spouse included in insurance cover, can the IIT spouse still purchase the Top-Up?",
            ans: "Yes. IIT alumni can purchase this on behalf of themselves and family.",
        },
        {
            ques: "I do not have any base insurance, can I subscribe to the Super Top-Up? How does it work then?",
            ans: "Yes, you can still subscribe to the Super Top-Up. In such a case, you will have to bear medical expenses equivalent to the initial deductible amount from your pocket."
        },
        {
            ques: "Once this plan comes into force, I hope any alumni/faculty should be allowed to join the plan at any point of time based on the allowable age limit.",
            ans: "Alumni/faculty can join during the period only once when the enrolment period is open. All alumni are eligible to join the plan next year. It is in the best interest of the group as well as unforeseen health-related circumstances that we don't defer the joining. ",
        },
        {
            ques: "Would it require health check-up/test before enrolment?",
            ans: "No, there is no requirement for a health check-up. In contrast, almost all individual plans require a medical test, which is often a hassle.",
        },
        {
            ques: "If two IITians are married does it make sense to have the younger spouse buy this for the family?",
            ans: "No. The age of the oldest member in the family unit is considered to arrive at the slab rate.",
        },
        {
            ques: "Who will determine alumni status? For instance, will executive MBA or executive fellow program students be considered ‌alumni? ",
            ans: "IITRAA considers all those who successfully passed courses of 1 year or longer duration as eligible participants for the insurance programs. These programs are B.Arch,<br/> M.Arch, <br/>MBA,<br/> IMS,<br/>B.Tech,<br/> BS-MS, <br/> M.Tech,<br/>IMT,<br/> MBA,<br/> M.Sc,<br/>IDD, <br/>MURP, <br/>PG DIPOLMA,<br/>M.Des,<br/>PHD,<br/>MIM",
        },
        {
            ques: "The age is the sign-up age or the actual age at the time of premium payment?",
            ans: "Age is the completed age(age as of last birthday) as on the premium payment date.",
        },
        {
            ques: "If an alum crosses 85 years, and the alum's spouse at that stage is less than 85 years, would the spouse continue to get enrolled in the policy after the alumni crosses 85 years",
            ans: "85 years is the limiting age for the first-time entry into the policy and not subsequent time. Once the alum enters the policy before 85 years of age, he/she can renew the policy even after crossing 85 years. It is mandatory for alumni to be the proposer, hence alumni have to take policy under eligible conditions, only then, he/she can add a spouse and kids. It is strongly recommended to enrol today than wait to turn 85 years",
        },
        {
            ques: "I understand that 85 years is only the entry age criteria for alumni and the policy will continue beyond 85 years of age too, for the life of this product. Please confirm this understanding",
            ans: "Yes, this is correct.",
        },
        {
            ques: "Is the policy open to alums who are now foreign citizens, while parents still hold Indian citizenship?",
            ans: "Yes. Alum will have to enroll himself/herself to avail the policy for parents/in-law's. Since the policy jurisdiction is in India, this can be used for treatments in India after the deductibles are also spent in India.",
        },
        {
            ques: "My daughter is 29 years old and stays with us. She has a base policy. Can she be included in this policy?",
            ans: "No, the age limit for adding children is up to 24 years. ",
        },
        {
            ques: "Can siblings be included?",
            ans: "No. Only spouses, kids and parents and parents-in-law are allowed.",
        },

        {
            ques: "Can we take only parent policy without ASK(Alumni, Spouse, Kid) policy?",
            ans: "It is mandatory for alumni to take at least policy for themselves, post which the alumni can take policy for parents.",
        },


        // coverage
        { ques: "Who is the TPA?", ans: "In-house TPA of CARE HEALTH INSURANCE." },
        {
            ques: "If I get married in the future, will I be able to add my spouse at no extra cost? Also, children in future?",
            ans: "Yes. Mid-term inclusion is allowed for life-changing events, such as marriage, childbirth and adoption. One can add a spouse and parents-in-law on getting married and children on birth/adoption. Simply send an email within 10 days of such a life-changing event to IITRAAhealthplan@zopperinsurance.com and we will get back to you with the process details.",
        },
        {
            ques: "Are you exploring having a base policy also, for the interested folks?",
            ans: "It was observed that many IIT alumni were either covered by their employer or on their own for the base cover. The idea was to provide a second safety net to the IIT alumni community with a much higher sum insured.",
        },
        {
            ques: "Is a base policy in my name a requisite for this plan? If I am covered up to 3 Lakhs by my spouse's policy, can I go ahead and enroll in this Top-Up plan without having a base policy in my name?",
            ans: "Base policy is not a prerequisite. Yes, you can enroll with the deductible as per options.",
        },
        {
            ques: "If we have existing insurance, can this also be taken additionally or can we switch our existing plan with this insurance?",
            ans: "This is an additional super Top-Up plan and hence we suggest holding onto your existing base.",
        },

        {
            ques: "I have a base policy from my employer where there is no waiting period. If I take the IITRAA Super Top-Up this year but leave my job over the course of next year, what happens to the waiting period when I renew the super Top-Up plan next year?",
            ans: "Top-up policy has nothing to do with the base policy provided by your employer. Super Top-Up will get triggered once you cross the deductible option chosen.",
        },
        {
            ques: "Why are aspects like maternity not part of it?",
            ans: "Maternity claims rarely go beyond Rs 3 Lakhs, which typically gets covered in the base policy and also the event is limited to a certain section of the population. Furthermore, most corporate policies cover maternity.",
        },
        {
            ques: "Would a consolidated list of coverage points be shared?",
            ans: "Yes, this will be provided by the insurer post policy issuance.",
        },
        {
            ques: "I am an NRI having global employer coverage and am 58 years old, retiring in 2 years. Should I take this now or should I take a base plan now for the 2 years and take this plan subsequently?",
            ans: "You can take this plan, as it will not disturb any of your base policy, this will be additional coverage apart from your base policy. But hospitalization has to be in India and the expenses against the deductible amount are to be spent in India.",
        },
        { ques: "Will Covid-19 treatment be covered?", ans: "Yes" },
        {
            ques: "Will the Top-Up work even if there is no base plan? Can the deductible of Rs 5 Lakhs be covered through self-insurance if required?",
            ans: "Yes. This will also work in case you are paying the deductible out of pocket.",
        },

        { ques: "Is there a co-pay in the policy for anyone?", ans: "No" },
        {
            ques: "If the alum passes away does the policy continue for the family?",
            ans: "Yes, the family will remain covered and family members are allowed to be covered in the next renewal as well. ",
        },
        {
            ques: "Both of us, husband and wife, are alumni. If the policy holder passes away can the cover be passed on to the remaining alumni spouse?",
            ans: "Yes. That is possible because, for the next year, the survivor can join the plan on the basis of his/her status as an alumni.",
        },
        {
            ques: "Can we take a multi-year Top-Up? Say 3 years?",
            ans: "No. The policy period is 1 year and will come up for renewal next year",
        },
        {
            ques: "What if your base plan is in the US but does not cover medical expenses out of the US. Thus, will all expenses above deductible be covered by the super Top-Up policy?",
            ans: "Yes, for hospitalization in India. The deductible has to be spent in India for the top-up policy to trigger.",
        },
        {
            ques: "Please mention the list of modern treatments.",
            ans: "•Uterine Artery Embolization and HIFU( High Intensity focused ultrasound )<br/>•         Balloon Sinuplasty<br/>•         Deep Brain Stimulation<br/>•         Oral Chemotherapy<br/>•         Immunotherapy: Monoclonal Antibody to be given as injection<br/>•         Intra Vitreal injections<br/>•         Robotic Surgery<br/>•         Stereotactic radio surgeries<br/>•         Bronchial Thermoplasty   <br/>•         Vaporisation of prostrate ( Green laser treatment or holmium laser treatment )<br/>•         IONM- ( Intra Operative Neuro Monitoring )<br/>•         Stem Cell Therapy: Hematological conditions to be covered ",
        },
        { ques: "Do I have to declare PEDs(pre-existing diseases)?", ans: "Yes, during the enrollment process, make sure to declare all PEDs (pre-existing diseases) for all family members. " },
        {
            ques: "How to declare pre-existing diseases for the risk-assessment/ under-writing? What happens after the payment?",
            ans: "PED is to be declared during the enrolment process.",
        },
        {
            ques: "If I am diagnosed outside of India can I avail this policy within India if I seek medical assistance within India?",
            ans: "Yes",
        },


        // pricing

        {
            ques: "What is the expected rise in premium years on year?",
            ans: "It is tough to say but huge changes are unlikely. The price depends on factors like claim ratio and demographics etc - it could increase. If the alumni association negotiates for a higher cover/deductible it may have an impact on prices. An increase in coverage in the number of persons will also impact prices- 3 children, parents, in-laws etc. If you look at the pricing table, the number of members in the group is a significant criterion. To mitigate any rise in premiums due to this factor, we must ensure that there is maximum participation from our alumni group.",
        },
        { ques: "is the premium annual or monthly?", ans: "Annual" },
        {
            ques: "Do premiums for people over 85 years vary each year?",
            ans: "The costs would be standard for people above 85 years and would not vary by person but the costs for each slab would vary depending on the claim ratio and the total number of alumni who sign up (the entire group and not the age band).",
        },
        {
            ques: "Will premium increases be the same for everyone or will it increase the basis of an individual's past claims?",
            ans: "This is a group plan and hence the price decrease or increase will be for the entire group, by age band.",
        },
        {
            ques: "Most people above 60 years won't have kids below 25, so effectively you are paying a lot for 2 people.",
            ans: "Your pricing will be based on the rates applicable.",
        },

        // process of registration
        {
            ques: "What about mobile numbers and addresses?",
            ans: "Registered Mobile numbers can be international but addresses will have to be of India",
        },
        { ques: "Is the enrolment process digital?", ans: "Yes" },

        {
            ques: "How can I enroll for the program? Can you provide the portal link or app link?",
            ans: "Alumni/faculty can enroll for the program through the IITRAA portal only to ratify that this program goes only to IIT Madras Alumni. The link to the portal is <br/><a href = \"https://IITalumni.com/\" target = \"_blank\">https://IITalumni.com/</a>"
        },

        {
            ques: "There's a field called passing year, what do I need input here?",
            ans: "You can also enter the year you graduated from IIT in the last applicable course you attended.",
        },

        {
            ques: "A lot of people are not yet on the IITRAA portal. Can they purchase the insurance policy only through the IITRAA portal? ",
            ans: " Alumni will have to enroll through the IITRAA portal. The IIT Alumni Office is supporting IIT Alumni Association in the process of signing up on the IITRAA portal.",
        },

        // payments receipts and section 80D
        {
            ques: "Are payments for Super Top-Up Policy eligible for 80D or do we get an income tax rebate for insurance?",
            ans: "Yes",
        },
        {
            ques: "Who issues the receipt for the payment made by an individual - the insurance company or the alumni association?",
            ans: "Receipts against funds transferred would be issued by the insurer.",
        },
        {
            ques: "Which premiums can be claimed for the 80D benefit? ",
            ans: "Premium paid for self, family and parents can be claimed. Premium paid for parents-in-law cannot be claimed for 80D benefit as per the Income Tax rules."
        },
        {
            ques: "Post enrolment and a waiting period of 12 months, porting of existing Top-Up policy from another insurer - is it possible to consider ,an extension of the sum insured being ported/ or a reduction in premium proportion to the amount of sum insured being ported?",
            ans: "Porting is not possible.",
        },

        // claim process
        {
            ques: "Does a base and Top-Up policy not from the same company cause any complications in the claim process?",
            ans: "No. This Super Top-Up policy is not dependent on any base policy and has its own coverage and works post the deductible chosen.",
        },

        {
            ques: "How would cashless work, with a deductible of Rs 3/5/7/10 Lakh? ",
            ans: "One has to submit proof of bill payment up to Rs 3/5/7/10 Lakh post which cashless claim will work in all network hospitals of CARE.",
        },
        {
            ques: "If a deductible is paid by another medical insurance, will the limit of the other insurance have to be utilized before this policy kicks in?",
            ans: "Not necessarily, but the deductible chosen has to be paid either by you or any insurance policy taken by you before."
        },
        {
            ques: "I have an Rs 5 Lakhs employer cover. If I have a Rs 5 Lakhs claim, can I claim under this policy?",
            ans: "A claim in excess of Rs 5 Lakhs will be covered if you have chosen a deductible of 5 Lakhs.",
        },
        {
            ques: "What happens in case of more than 1 claim in a single financial year? Will the deductible limit be applied for both claims or only for the first claim?",
            ans: "Deductible chosen Rs 3/5/7/10 Lakhs applies for multiple events in the same year (it is an aggregate deductible).",
        },
        {
            ques: "Is there any limit on the claim amount for each person in the policy?",
            ans: "For example policy cover is Rs 25 lakhs with Rs 5 lakhs deductible. Alumni can claim a maximum of up to the sum insured chosen. The policy triggers after the deductible amount.",
        },
        {
            ques: "What role will Zopper play in the claims process?",
            ans: "Zopper would assist the alumni in the claim process. It would help through the insurer and TPA(if any) to ensure that the interests of the alumni and family are protected.",
        },
        {
            ques: "Can we involve Zopper in the claim process? Is there any 24/7 number or email?",
            ans: "Yes, Zopper will help in claim processing, email ID is <u><a>IITRAAhealthplan@zopperinsurance.com </a></u>",
        },
        {
            ques: "Do I need to raise a claim of Rs 3 Lakhs even when I know that it will not be approved as I chose deductible as Rs 5 Lakhs?",
            ans: "No, at the time of claiming in the super Top-Up policy, you can show the bill receipt up to the deductible and proceed with IIT Super Top-Up Group plan.",
        },
        {
            ques: "If my parents medical expenses are claimed through my employer group insurance , can I claim after the deductible with this Super Top-Up policy?",
            ans: "Yes, you can.",
        },
        {
            ques: "If I am self insured i.e no base insurance, then how will claim processing work? Will it be cashless ? How will the insurers know that I have spent Rs 5 lakhs during the year?",
            ans: "When you want to claim on the IITRAA Super Top-Up Group policy, you will have to present the receipt of payment up to deductible to the insurer and from there the Super Top-Up policy will get picked up. For any assistance, Zopper Team will be there for support",
        },
        {
            ques: "Will there be any no claim bonus for subsequent renewals, if no claim is made or proportional cover is increased during renewal period?",
            ans: "This is not a retail policy. Hence, no claim bonus is not applicable. This is a group policy. The overall claims performance of the group and the overall group demographics decide the premium for the group across age bands. Practically, the group gets lower or higher rates based on last year’s performance rather than the individual alumni.",
        },
        {
            ques: "Are live sessions planned for addressing further questions?",
            ans: "Yes"
        },

        // renewal
        {
            ques: "If the premium is increased in the 2nd year, can I pull back if I do not like the price?",
            ans: "Once you pull out of the insurance policy, you will not be able to re-enter the program at a future date. Premiums increase with increasing healthcare costs and increasing the age of the insured.",
        },
        {
            ques: "Is entry into the policy possible at the time of renewal, if not opted now?",
            ans: "Yes. But since the success of the insurance program and the continuity will depend on the number of registrations in the current year, it is advisable to register now. This will also ensure that by next year, at the time of renewal, a PED waiting period waiver can be availed.",
        },
        {
            ques: "Will IITRAA continue to provide this policy with the same or other providers? So that once alumni are invested they get benefits for the long term.",
            ans: "Yes, definitely. IITRAA would continue to provide this but this is also dependent on good alumni participation.",
        },
        {
            ques: "Can we enter for self and spouse and add kids later during subsequent renewals - will the PED waiting period be treated differently?",
            ans: "Yes, you can add kids later during the next renewal. The PED waiting period for anyone entering the policy will be 1 year from the time of first enrolment in the policy. For existing members, the PED wait period during the next renewal will be zero.",
        },
        {
            ques: " In case of the demise of alumni, the existing/ current year policy will be valid. Will renewal be applicable for spouses up to 65 years and how do they enroll for it? Will the registration window during renewal be open to them? This is important to secure the interests of family beyond us.",
            ans: "The current cover will be applicable until policy year renewal. This is as per this year. IITRAA will ensure to cover the family members of the deceased alumni every year. ",
        },
        {
            ques: "Can Zopper/ CARE consider intimating and committing 1 year of additional renewal/ cover before withdrawing this scheme for IIT alumni? This is required, in case alternate arrangements are to be made for alumni and their families, in the event of the scheme getting withdrawn.",
            ans: "The program will continue and IITRAA will look at continuity, until any regulation changes.",
        },
        {
            ques: " In case of renegotiation, how will the PED of 1 year work? If the insurer is changed, will the 1 year clause kick in again?",
            ans: "The PED waiver will be applicable in next year's policy renewal. PED waiver will be applicable for alumni this year, who had availed it last year. During renewal, the 1 year wait period on PED will apply only for fresh enrolments in the policy as well as for the increased sum insured.",
        },

        { ques: "Can one exit the plan and join back again?", ans: "No. Joining back again in the plan is not allowed. This is to discourage mala fide intentions to cover only the case of known future events." },
        {
            ques: "Will we get a better rate if we increase the deductible to 10 Lakhs?",
            ans: "Yes, you can choose a Rs 10 Lakhs deductible for a better rate. It might be better to go for Rs 10 Lakhs deductible if your base policy covers up to Rs 10 Lakhs.",
        },

        {
            ques: "Who will administer this plan? Who is the insurer and who is the TPA?",
            ans: "The IIT Alumni Association will administer the plan. CARE is the insurer and Zopper Insurance Brokers Private Limited is the broker.",
        },

        {
            ques: "Which account will my premium payment be transferred to?",
            ans: "The amount collected for the premium will be transferred to the insurer directly.",
        },

        {
            ques: "Will there be an age bar at any time/renewal?",
            ans: "85 years is the last entry age for alums. Once an alum or a family member enters the program, he/she can continue renewing the policy in subsequent years as long as the insurance program continues with IITRAA..",
        },
        // i am here

        {
            ques: "If the deductible chosen is 5 Lakhs and I take 3 policies (immediate family, parents and parents-in-laws), then will Rs 5 Lakhs be deducted for each of the 3 policies or just once whichever gets triggered first?",
            ans: "If you have chosen a deductible of Rs 5 Lakhs for each policy then for each policy Rs 5 Lakhs should be paid by you or through any other insurance plan post which Super Top-Up plan will trigger. Deductible will work separately on each policy combination - Alumni, Spouse and Kids, up to 2 parents, and up to 2 parents-in-law.",
        },

        {
            ques: "If we choose a base deductible as Rs 7 Lakhs, we have a base policy of Rs 3 Lakhs with one insurance provider, Rs 10 Lakhs Top-Up with another service provider with Rs 3 Lakhs deductible, will this Super Top-Up work beyond Rs 7 Lakhs? How are cashless cases settled in that case?",
            ans: "If in the Super Top-Up plan you have chosen a deductible of Rs 7 Lakhs then you will have to produce a receipt of payment upto Rs 7 Lakhs(that can be paid by you or any of your insurance plans) beyond which cashless will be settled in the network hospital up to the sum insured.",
        },

        {
            ques: "Can we increase or decrease the amount year on year? For example: if in year 1, I start with Rs 30 Lakhs, can I reduce it to Rs 20 Lakhs in year 2 and visa-versa?",
            ans: "Yes, increasing or reducing the sum insured is allowed. However, next year, if you increase the Sum Insured, the waiting period will apply to the incremental amount.",
        },

        {
            ques: "Can I delete any member from the program during renewal?",
            ans: "You can, but you will not be able to add them back during the next and subsequent renewals. It is advised to remove/delete members only on account of lids changing events such as death, divorce/legal separation, child reaching the age of 25 years. ",
        },

        {
            ques: "Can we have a list of network hospitals?",
            ans: "Yes, please check the list of hospitals here <br/><u> <a href='https://www.careinsurance.com/smart-select-network-locator.html?state=19&button=Submit' target='_blank'> https://www.careinsurance.com/smart-select-network-locator.html?state=19&button=Submit</a></u>. You can also find it my mailing to <u><a href = \"mailto:iitraahealthplan@zopperinsurance.com\">iitraahealthplan@zopperinsurance.com</a></u>",
        },

        {
            ques: "Can we register for a smaller sum insured now and increase it during renewal? In that case will the waiting period for the original sum assured be waived and only for the differential sum insured, the additional waiting period of 12 months will apply - Please confirm otherwise, it should not be one more set of 12 months including the original sum assured for the whole policy, though we have a pre existing policy.",
            ans: "Yes, it is possible to increase the sum insured in the next renewal.  For incremental sum insured chosen next year, the waiting period of 1 year on PED will apply. ",
        },

        // comparison with other insurers
        {
            ques: "CARE is not a well known company like New India, or large private companies. Are they reliable? Will they pay up? Is there any escalation process if there is a dispute? Will IITRAA help out?",
            ans: "CARE has a claims settlement ratio of 95% which is really good in the industry, there has been a proper assessment and comparison made on the quotes, please note all the players in the industry are highly regulated and monitored by IRDA. Therefore there is no doubt about the credibility of the insurer. PSU companies did not provide all the benefits that are provided in the Super Top-Up plan as per their underwriting appetite.Yes, IITRAA and Zopper both will help during the process and any wrong claim rejection and as per merit of the case.",
        },
        
    ],
    disclaimerText : (
        `<p className="text-sm">
          The   information   contained   in   this   presentation   and   related   communication
          material   (“Presentation”)   is   intended   solely   for   the   personal   reference   of   the
          Alumni of IIT. Such information is subject to change without notice, its
          accuracy   is   not   guaranteed   and   it   may   not   contain   all   material   information
          concerning   the   proposal   for   seeking   interest   of   the   Alumni   community   to
          subscribe to a group insurance super-top up plan (“Proposed Product”).
          <br />
          The IIT Alumni Association   (“IITRAA”)   makes   no   representation   regarding,   and
          assumes no responsibility or liability for, the accuracy or completeness of, or any
          errors or omissions in, any information contained herein. These views are based
          on current assumptions which are subject to various risks and which may change
          over   time.   No   assurance   can   be   given   that   future   events   will   occur,   that
          projections   will   be   achieved,   or   that   the   assumptions   are   correct.   It   is   not   the
          intention to provide, and you may not rely on this presentation as providing, a
          complete or comprehensive analysis of the proposed product. This presentation
          does   not   constitute   an   offer   or   invitation   to   purchase   or   subscribe   for   the
          proposed Product, and no part of it shall form the basis of or be relied upon in
          connection   with   any   contract,   commitment   or   investment   decision   in   relation
          thereto.   The   contents   are   not   to   be   reproduced   or   distributed   to   the   public   or
          press. Each person who has received a copy of this and further communications
          on this program, is deemed to have agreed:
          
          <ul>
            <li>
              i) not to reproduce or distribute this presentation, in whole or in part,
            </li>
            <li>
              ii) not to disclose any information contained in
              this presentation. All photos, logos etc. used in the presentation are the property
              of their respective copyright owners and are used here for information purpose
              only within the closed group of IIT alumni.
            </li>
          </ul>
        </p>`
    ),
    featuresMap:[
        // {
        //   ques: "Cashless Facility",
        //   ans: "Yes, available.",
        // },
        // {
        //   ques: "Reimbursement Facility",
        //   ans: "Yes, available.",
        // },
        // {
        //   ques: "In-Patient Hospitalisation Covered",
        //   ans: "Yes",
        // },
        // {
        //   ques: "Hospitalisation at Home",
        //   ans: "Covered",
        // },
        // {
        //   ques: "Available Sum Insured Options",
        //   ans: "₹ 10 Lakh / ₹ 15 Lakh / ₹ 20 Lakh / ₹ 25 Lakh / ₹ 30 Lakh /<br/> ₹ 50 Lakh / ₹ 75 Lakh /  ₹ 1 Crore",
        // },
        // {
        //   ques: "Deductible",
        //   ans: "INR 3 Lakh, INR 5 Lakh and INR 7 Lakh",
        // },
        // {
        //   ques: "Day Care Treatment Covered",
        //   ans: "Normal - Any category room except suite<br/>ICU - On actuals",
        // },
      
        // {
        //   ques: "Pre & Post Hospitalisation Expenses Covered",
        //   ans: "Yes<br/>Pre - 30 Days<br/>Post - 60 Days",
        // },
      
        // {
        //   ques: "Ambulance Covered",
        //   ans: "Yes, for up to ₹5,000 per hospitalisation",
        // },
        // {
        //   ques: "Donor Expenses",
        //   ans: "Covered",
        // },
        // {
        //   ques: "Waiting Period in The Policy",
        //   ans: "For new enrollments <br/> Initial waiting period- 30 Days(except for injury / accident) <br/> Specific disease waiting period - 12 Months <br/> Pre-existing disease waiting period - 12 Months",
        // },
        // {
        //   ques: "Modern treatments",
        //   ans: "Uterine artery embolization and HIFU (High intensity focused ultrasound).<br/>Balloon sinuplasty.<br/>Deep brain stimulation.<br/>Oral chemotherapy.<br/>Immunotherapy – Monoclonal antibody to be given as injection.<br/>Intra vitreal injections.<br/>Robotic surgeries.<br/>Stereotactic radio surgeries.<br/>Bronchial thermoplasty.<br/>Vaporisation of the prostrate (green laser treatment or holmium laser treatment).<br/>IONM - (Intra Operative Neuro Monitoring).<br/>Stem cell therapy: hematopoietic stem cells for bone marrow transplant for haematological conditions to be covered.",
        // },
        // {
        //   ques: "Wellness programs",
        //   ans: "Teleconsultation – tie up with MFine, unlimited teleconsultations with general physician.<br/>Home Healthcare – Up to 15% off on home healthcare service, tie up with Portea<br/>Health checks & diagnostics – Upto 70% + 10% discount on diagnostic tests & health checks, tie up with Pharmeasy & MFine.<br/>Priority Dental & Oral Health Appointments – tie up with Clove; upto 50% off on X Rays & routine dental treatments.<br/>Pharmacy & Nutraceuticals – tie up with Pharmeasy, upto 15% + 5% extra discount on prescription medicine.<br/>Yoga & Mindfulness – tie up with Cult fit, 21 days complimentary access to virtual(at home) yoga sessions.",
        // },
        {
          ques: "Pre-policy Medical Check-up",
          ans:"Declaration bases"
        }, {
          ques: "Policy Tenure ",
          ans:"1 Year"
        },
        {
          ques: "Claims pay-out",
          ans:"Cashless within network / Re-imbursement"
        },
        {
          ques: "Claims Servicing",
          ans:"In - house"
        },
        {
          ques: "In - patient care",
          ans:"Up to Sl"
        },
        {
          ques: "Day Care Treatment",
          ans:"Up to Sl"
        },
        {
          ques: "Pre-hospitalization Medical expenses",
          ans:"30 days"
        },
        {
          ques: "Post-hospitalization Medical expenses",
          ans:"60 days"
        },
        {
          ques: "Domestic Road Ambulance",
          ans:"Up to Rs.5000 per hospitalization"
        },
        {
          ques: "Donor Expenses",
          ans:"Up to Sl"
        },
        {
          ques: "Domiciliary hospitalization",
          ans:"Up to Sl; if it continues for a period exceeding 3 consecutive days"
        },
        {
          ques: "Waiting period of 30 Days",
          ans:"Yes (except for Injuries/Accident)"
        },
        {
          ques: "Waiting period for Named Ailment (as defined in Group Care 360 Product)",
          ans:"12 Months"
        },
        {
          ques: "Waiting period for Pre-existing diseases",
          ans:"12 Months"
        },
        {
          ques: "On Room rent sub limits",
          ans:"Any kind of room except suite"
        },
        {
          ques: "ICU charges",
          ans:"No Limits"
        },
      ],
    clientlink: 'iitraa.in',
    clientName: 'IITRAA',
    clientDisplayName: 'IITRAA',
    supportMail:'iitraahealthplan@zopperinsurance.com'
}